import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import responderAuthReducer from "./slices/responderAuthSlice";
import notificationReducer from "./slices/notificationSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "./api/baseApi";
import { responderApi } from "./api/responderApi";
import { fileApi } from "./api/fileApi";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    responderAuth: responderAuthReducer,
    notifications: notificationReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [responderApi.reducerPath]: responderApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["fileApi/executeMutation"],
        ignoredPaths: ["fileApi.mutations"],
      },
    }).concat(baseApi.middleware, responderApi.middleware, fileApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
